const MAX_RELOADS = 2;
const RELOAD_KEY = 'chunk_reload_count';

window.addEventListener('error', (e) => {
  if (e.message && e.message.includes('ChunkLoadError')) {

    let reloadCount = Number(sessionStorage.getItem(RELOAD_KEY)) || 0;

    if (reloadCount < MAX_RELOADS) {
      reloadCount++;
      sessionStorage.setItem(RELOAD_KEY, String(reloadCount));

      console.log(`Reload attempt ${reloadCount}`);
      window.location.reload();
    } else {
      console.error('Chunk load failed after multiple attempts.');

      // Optional: show fallback UI or redirect
      alert('App failed to load. Please clear cache or try again later.');
    }
  }
});

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
